import Mention from "@tiptap/extension-mention";
import { mergeAttributes } from "@tiptap/core";
import { createCollaborateSignoffSuggestion } from "./createCollaborateSignoffSuggestion";
import type { CollaborateUser } from "../types/collaborate";

export function createSignoffMentionExtension(getUsers: () => CollaborateUser[]) {
  return Mention.extend({
    name: "signoff",

    renderHTML({ node, HTMLAttributes }) {
      const assignee = `@${node.attrs.label ?? node.attrs.id}`;
      return [
        "span",
        { class: "collaborate-signoff-inline", "data-signoff-inline": "true" },
        [
          "span",
          { class: "collaborate-signoff-chip" },
          ["span", { class: "collaborate-signoff-chip__tag" }, "Sign-off"],
          [
            "span",
            mergeAttributes(HTMLAttributes, { class: "collaborate-signoff-chip__assignee" }),
            assignee,
          ],
        ],
      ];
    },
  }).configure({
    HTMLAttributes: { class: "collaborate-signoff-mention" },
    renderLabel: ({ node }) => `@${node.attrs.label ?? node.attrs.id}`,
    suggestion: createCollaborateSignoffSuggestion(getUsers),
    deleteTriggerWithBackspace: true,
  });
}
